import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from './views/dashboard/dashboard1.vue';
import Profile from './views/profile/profile.vue';
import Profile_Update from './views/profile_edit/profile_edit.vue';
// import StudentDashboard from './views/Student_dashboard/Student_dashboard.vue';

Vue.use(VueRouter);
const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login/login.vue'),
      meta: {
        requiresAuth: false,
        guest: true,
      }
    },
    
    {
      path: '/my_profile',
      name: 'profile',
      component: Profile,
      meta: {
        title: 'Profile',
        requiresAuth: true,
      },
    },
    {
      path: '/my_profile_update',
      name: 'profile_update',
      component: Profile_Update,
      meta: {
        title: 'Profile_Update',
        requiresAuth: true,
      },
    },
    {
      path: '/',
      name: 'home',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
        requiresAuth: true,
      },
    },

    {
      path: '/all_job_listings',
      name: 'all job',
      component:() => import('./views/all_job_view/all_job_view.vue'),
      meta: {
        title: 'All Job View',
        requiresAuth: true,
      },
    },
    {
      path: '/draft_job',
      name: 'draft_job',
      component: () => import('./views/all_draft_job_view/all_draft_job_view.vue'),
      meta: {
        title: 'Draft Job',
        requiresAuth: true,
      },
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('./views/search/search.vue'),
      meta: {
        title: 'Search',
        requiresAuth: true,
      },
    },
    {
      path: '/applied_job_list',
      name: 'applied_job',
      component: () => import('./views/applied_job_list/applied_job_list.vue'),
      meta: {
        title: 'Applied Job',
        requiresAuth: true,
      },
    },

    {
      path : '/search_job',
      name: 'search_job',
      component : () => import('./views/all_job_after_search/all_job_after_search.vue'),
      meta : {
        title : 'Job Found',
        requiresAuth : true
      }  
    },
    {
      path: '/job-application',
      name: 'job-application',
      component: () => import('./views/job-application/job-application.vue'),
      meta: {
        title: 'Job Posting',
        requiresAuth: true,
      },
    },
    {
      path: '/update-job-application/:id',
      name: 'update_job-application',
      component: () => import('./views/update_job-application/update_job-application.vue'),
      meta: {
        title: 'Update Job',
        requiresAuth: true,
      },
    },
    {
      path: '/job-application/:id',
      name: 'job-application-details',
      component: () => import('./views/job_details/job_details.vue'),
      meta: {
        title: 'Job Posting',
        requiresAuth: true,
      },
    },
    {
      path: '/recomended_talent/:id/:test',
      name: 'recomended_talent',
      component: () => import('./views/recomended_talent/recomended_talent.vue'),
      meta: {
        title: 'Invite Talent',
        requiresAuth: true,
      },
    },
    {
      path: '/invite_talent/:id/:test',
      name: 'invite_talent',
      component: () => import('./views/invite_talent/invite_talent.vue'),
      meta: {
        title: 'Invite Talent',
        requiresAuth: true,
      },
    },
    {
      path: '/applied_candidate/:id/:test',
      name: 'applied_candidate',
      component: () => import('./views/applied/applied.vue'),
      meta: {
        title: 'Applied Candidate',
        requiresAuth: true,
      },
    },
    {
      path : '/candidate_details/:id/:test',
      name: 'candidate_details',
      component : () => import('./views/candidate_details/candidate_details'),
      meta : {
        title : 'Candidate Details',
        requiresAuth : true
      }  
    },
    {
      path : '/send_email/:id',
      name: 'send_email',
      component : () => import('./views/send-email/send-email.vue'),
      meta : {
        title : 'Send email',
        requiresAuth : true
      }  
    },
    {
      path : '/hire/:id',
      name: 'hire',
      component : () => import('./views/hire/hire.vue'),
      meta : {
        title : 'Hire',
        requiresAuth : true
      }  
    },
    {
      path : '/peekJ/:id',
      name: 'peekhire_job_application',
      component : () => import('./views/peek_hire_job-application/peek_hire_job-application.vue'),
      meta : {
        title : 'Interview2',
        requiresAuth : true
      }  
    },
    // {
    //   path: '/view_candidate',
    //   name: 'View_candidate',
    //   component: () => import('./views/view_candidate/view_candidate.vue'),
    //   meta: {
    //     title: 'View Candidate',
    //     //requiresAuth: true,
    //   },
    // }, 
    {
      path: '/question-upload',
      name: 'question-upload',
      component: () => import('./views/question-upload/question-upload.vue'),
      meta: {
        title: 'Question Upload',
        requiresAuth: true,
      },
    },
    {
      path: '/view-candidate',
      name: 'view-candidate',
      component: () => import('./views/view_candidate/view_candidate.vue'),
      meta: {
        title: 'View/Assess Candidates',
        requiresAuth: true,
      },
    },
    {
      path: '/view-candidate/review_candidate',
      name: 'review_candidate',
      component: () => import('./views/review_candidate/review_candidate.vue'),
      meta: {
        title: 'Review Candidates',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/forum',
      name: 'Forum',
      component: () => import('./views/Forum/forum.vue'),
      meta: {
        title: 'Forum',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/start-discussion',
      name: 'start-discussion',
      component: () => import('./views/forum_chat/forum_chat.vue'),
      meta: {
        title: 'start-discussion',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/discussion/:id',
      name: 'forum_discussion',
      component: () => import('./views/Forum_discussion/forum_discussion.vue'),
      meta: {
        title: 'Forum Discussion',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/my-jobs',
      name: 'my-jobs',
      component: () => import('./views/my_jobs/my_jobs.vue'),
      meta: {
        title: 'My Jobs',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/applicats-job/:id',
      name: 'applicants_job',
      component: () => import('./views/applicants_job/applicants_job.vue'),
      meta: {
        title: 'Applicants Job',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/shorlisted_candidate/:id/:test',
      name: 'shortlist_candidate',
      component: () => import('./views/shortlist_candidate/shortlist_candidate.vue'),
      meta: {
        title: 'Shortlist Candidate',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/candidate-alerts',
      name: 'candidate_alerts',
      component: () => import('./views/candidate_alerts/candidate_alerts.vue'),
      meta: {
        title: 'Candidate Alerts',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/change_password',
      name: 'change_password',
      component: () => import('./views/change_password/changePassword.vue'),
      meta: {
        title: 'Change Password',
        requiresAuth: true,
      }, 
      
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('./views/register/register.vue'),
      meta: {
        requiresAuth: false,
        guest: true,
      }
    }, 
    {
      path: '/verify_otp',
      name: 'verify_otp',
      component: () => import('./views/VerifyOtp/verify_otp.vue'),
      meta: {
        requiresAuth: false,
        guest: true,
      }
    }, 
  ],

  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.log("tken kejrjr",localStorage.getItem('jwt'));
    if (localStorage.getItem('jwt') == null) {
      next({
        path: '/login',
        params: { nextUrl: to.path },
      });
    } else {
      next();
    }
  } else {
    next();
  }

});

export default router;


